export const HEVO_DARK_THEME_LOGO_SVG =
  'https://res.cloudinary.com/hevo/image/upload/v1762931622/dashboard/hevo-logos/svg/white_hxnfzp.svg';
export const HEVO_LIGHT_THEME_LOGO_SVG =
  'https://res.cloudinary.com/hevo/image/upload/v1762931621/dashboard/hevo-logos/svg/dark_a4vovy.svg';
